export default __webpack_public_path__ + "static/carousell-os-car-valuation-icon-price-match-and-inspections-aa075991958c2b5fc6687cd2a0f04641.svg";